import type { HeaderSettingsAlertCheck, HeaderSettingsAlertIssue } from 'utils/headerSettingsAlert/types';
import { classifyFacebookHealth } from 'views/company/facebook/facebook-health-classify';

export const FACEBOOK_SETTINGS_FIX_PATH = '/system-settings/facebook-notifications';

const SUMMARY_PATHS = {
  business: 'header.settingsAlert.summary.business',
  payment: 'header.settingsAlert.summary.payment',
  templates: 'header.settingsAlert.summary.templates',
} as const;

const FIX_TARGET = 'facebookSettings';

export const facebookNotificationsCheck: HeaderSettingsAlertCheck = {
  id: 'facebook-notifications',
  run(ctx): HeaderSettingsAlertIssue[] {
    const health = classifyFacebookHealth(ctx.facebookNotifications, ctx.company?.RegistrationStatus);
    const issues: HeaderSettingsAlertIssue[] = [];

    if (!health.business.ok) {
      issues.push({
        id: 'facebook-business',
        messagePath: SUMMARY_PATHS.business,
        fixPath: FACEBOOK_SETTINGS_FIX_PATH,
        fixTargetKey: FIX_TARGET,
      });
    }
    if (!health.payment.ok) {
      issues.push({
        id: 'facebook-payment',
        messagePath: SUMMARY_PATHS.payment,
        fixPath: FACEBOOK_SETTINGS_FIX_PATH,
        fixTargetKey: FIX_TARGET,
      });
    }
    if (!health.templates.ok) {
      issues.push({
        id: 'facebook-templates',
        messagePath: SUMMARY_PATHS.templates,
        fixPath: FACEBOOK_SETTINGS_FIX_PATH,
        fixTargetKey: FIX_TARGET,
      });
    }

    return issues;
  },
};
